import { Component, ViewChild,  ElementRef, OnInit, TemplateRef, ViewContainerRef, Input} from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { AddProductDialogComponent } from '../add-product-dialog/add-product-dialog.component';

import * as XLSX from 'xlsx';

import { PriceDialogComponent } from '../price-dialog/price-dialog.component'; 

import { TextDescriptionDialogComponent } from '../text-description-dialog/text-description-dialog.component'; 
import { AudioDescriptionDialogComponent } from '../audio-description-dialog/audio-description-dialog.component'; 
import { QrCodeDescriptionDialogComponent } from '../qr-code-description-dialog/qr-code-description-dialog.component'; 
import { PhotoDialogComponent } from '../photo-dialog/photo-dialog.component'; 

import { GestockService } from '../services/gestock.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

 
import { MatSnackBar } from '@angular/material/snack-bar';

import { DepotDialogComponent } from '../depot-dialog/depot-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


@Component({
  selector: 'app-stock-entree',
  templateUrl: './stock-entree.component.html',
  styleUrls: ['./stock-entree.component.css']
})
export class StockEntreeComponent implements OnInit {


	searchTerm: string = '';
	page: number = 1;

    productYeupp = [] ;

	itemsPerPage = 25;
	currentPage = 1;

    block = 1;

    templateProduct = {
					    id: 0,
					    name: '',
					    quantity: {
					      qteTotal: 0,
					      stocksParDepot: [
					      ]
					    },
					    entryPrice: 0,
					    salePrice: 0,
					    prices: { gros: 0, demiGros: 0, detail: 0 },
					    category: '',
					    description: '',
					    audioUrl: '',
					    imageUrl: '',
					    stockIn: 0,
					    stockOut: 0
					} ;



	leStock : any ;

	previewProducts: any[] = [];

	selectedProducts: any[] = [];


	newCategory: string = '';

	showSearch = false;
	showFilter = false;
	selectedCategories: string[] = [];

    samacaabiyoonwii = "" ;
    porteeUser : any = "" ;
    action : any = "" ;


    filteredproductsdatasource = [] ;



	selectedBoutique: string = 'Toutes';

    retourClientWS : any ;


    makepost = 0 ;

    @Input() products : any ; 
	@Input()  categories: string[] ; //['Accessoires', 'Pièces détachées', 'Motos' ];
	@Input() boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
	@Input() allPoints = [] ;
	@Input() tousLesDepots = [] ;

	choosedPoint : any ;

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	dataSource = new MatTableDataSource<any>(); // ou adapte ton type


	displayedColumnsProdTable: string[] = ['category', 'name', 'qteTotal', 'entryPrice', 'gros', 'demiGros', 'detail'];

	displayedColumns: string[] = ['ref', 'designation', 'qteStock', 'cmup', 'gros', 'demiGros', 'detail'];


    @ViewChild('fileInput') fileInput!: ElementRef;

	@ViewChild('spinnerDialog', { static: false }) spinnerDialog: TemplateRef<any>;
	spinnerDialogRef : any ;


	@ViewChild('stockAdjustIn', { static: false }) stockAdjustInDialog: TemplateRef<any>;
	stockAdjustInDialogRef : any ;

	constructor(private dialog: MatDialog, private snackBar: MatSnackBar,
				private configServer: GestockService,  private viewContainerRef: ViewContainerRef) {}

	ngOnInit(){
		this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
	    this.porteeUser =  sessionStorage.getItem("portee") ;
	    this.action =  sessionStorage.getItem("action") ;
	   // this.getAllPoints(); 
	}


	updateDataSource() {
	  const filtered = this.products.filter(product => {
	    const matchesSearch = this.searchTerm === '' || product.name.toLowerCase().includes(this.searchTerm.toLowerCase());
	    const matchesCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(product.category);
	    return matchesSearch && matchesCategory;
	  });

	  this.dataSource.data = filtered;
	}

	getAllPoints(){
		this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    console.log("Done") ;
		    this.boutiques = this.retourClientWS.data ; 
		    if(this.boutiques.length==1)
		      this.selectedBoutique = this.boutiques[0].idPoint ;

			  this.dataSource.paginator = this.paginator;
			  this.dataSource.sort = this.sort;

		    this.getAllCategories() ; 			  	
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;    
	}

	onBoutiqueChange(): void {
		this.getAllCategories() ;
	}


	addPreviewedProducts() {
		this.openSpinnerDialog() ;
		this.configServer.addProductMasse(this.samacaabiyoonwii, this.previewProducts, this.choosedPoint.nompoint, "", "").then( (retourbi) => {
		  this.closeSpinnerDialog();
		  this.retourClientWS = retourbi ;
		  console.log(this.retourClientWS.data) ;

		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    this.previewProducts = [];
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
		/*this.previewProducts.forEach((product) => {
		this.products.push(product);
		});
		this.previewProducts = [];*/
	}

	adjustInventory() {
    	console.log("Ajuster Inventaire !!! ") ;
	}

	getAllCategories(){
		this.configServer.getAllCategories(this.samacaabiyoonwii).then( (retourbi) => {
		  this.getsamastock();

		  this.retourClientWS = retourbi ;
		  console.log(this.retourClientWS.data) ;
		  this.getAllPointsEtDepots() ;

		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		  	for (var i = 0; i < this.retourClientWS.data.length; i++) {
			    this.categories.push(this.retourClientWS.data[i].nomcategorie)  ;
		  	}
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
	}

	getPrix(product, opt){
		if(opt=="gros")
			return product.prices?.gros ;
		if(opt=="demiGros")
			return product.prices?.demiGros ;

		return product.prices?.detail ;
	}


	getsamastock(){		

		this.openSpinnerDialog(); 

		this.configServer.getsamastock(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {			
	      
	      this.closeSpinnerDialog(); 

		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    this.leStock = this.retourClientWS.data ;
		    this.getTheProducts() ;
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
	}

	reloadStock(){
		this.openSpinnerDialog() ;		  
		this.configServer.getsamastock(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {			
		  this.closeSpinnerDialog() ;		  
		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    this.leStock = this.retourClientWS.data ;
		    this.getTheProducts() ;
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
	}



  getAllPointsEtDepots(){
    this.configServer.getAllPointsEtDepots(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log("DEpotYI: ", this.retourClientWS.data) ;
      if(statutreq==1){
        this.allPoints = this.retourClientWS.data ;
        this.retenirJusteLesDepots() ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  onLieuxStructChange(event){
    this.choosedPoint = this.tousLesDepots[event.value] ;    
  }

  retenirJusteLesDepots(){
    for (var i = 0; i < this.allPoints.length; i++) {
      if(this.allPoints[i].type=="Depot"){
        this.tousLesDepots.push(this.allPoints[i]) ;
      }
    }
  }


	getTheProducts(){
		this.products = [] ;
		let allNames = [] ;
		for (var i = 0; i < this.leStock.length; i++) {
			let indexouArticleBi = allNames.indexOf(this.leStock[i].nom_article) ;
			if(indexouArticleBi==-1){
				this.updateTheLineInfos(this.products.length, this.leStock[i], 1) ;
				allNames.push(this.leStock[i].nom_article) ;
			}else{
				this.updateTheLineInfos(indexouArticleBi, this.leStock[i], 2) ;
			}
		}
		this.updateDataSource();
	}

	updateTheLineInfos(indexToUpdt, LaLigneEnStock, act){
		//act : 1==creation Nouvelle, 2==Mise à jour
		if(act==1){
			let baseElt = {
						    id: 0,
						    name: '',
						    quantity: {
						      qteTotal: 0,
						      stocksParDepot: [
						      ]
						    },
						    entryPrice: 0,
						    salePrice: 0,
						    prices: { gros: 0, demiGros: 0, detail: 0 },
						    category: '',
						    description: '',
						    audioUrl: '',
						    imageUrl: '',
						    stockIn: 0,
						    stockOut: 0,
						    detailsarticle : undefined
						} ;
			this.products.push(baseElt) ;
		}

		this.products[indexToUpdt].id = LaLigneEnStock.article_id ;
		this.products[indexToUpdt].name = LaLigneEnStock.nom_article ;

		this.products[indexToUpdt].quantity.qteTotal += LaLigneEnStock.qte_en_stock ;
		this.products[indexToUpdt].quantity.stocksParDepot.push({"nomDepot":LaLigneEnStock.depot_nom, 
																 "qteEnStock":LaLigneEnStock.qte_en_stock,
																 "idstock":LaLigneEnStock.id}) ;

		this.products[indexToUpdt].entryPrice = LaLigneEnStock.cmup ;
		this.products[indexToUpdt].prices = JSON.parse(LaLigneEnStock.prixvente) ;
		this.products[indexToUpdt].category = LaLigneEnStock.categorie ;
		this.products[indexToUpdt].description = JSON.parse(LaLigneEnStock.detailsarticle).description ;
		this.products[indexToUpdt].audioUrl = JSON.parse(LaLigneEnStock.detailsarticle).audioUrl ;
		this.products[indexToUpdt].imageUrl = JSON.parse(LaLigneEnStock.detailsarticle).imageUrl ;

		this.products[indexToUpdt].detailsarticle = JSON.parse(LaLigneEnStock.detailsarticle) ;
	}

	openAddProductDialog() {
	  const dialogRef = this.dialog.open(AddProductDialogComponent, {
	    width: '400px'
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result) {
	      this.getAllCategories(); 
	      //this.products.push(result); // Ajoute le produit à la liste
	    }
	  });
	}

	openPriceDialog(product: any) {
	  const dialogRef = this.dialog.open(PriceDialogComponent, {
	    width: '350px',
	    data: { product,  longbi:this.boutiques.length }
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result) {
	      product.prices = result; // Remplace les prix s’ils ont été modifiés
	    }
	  });
	}

	openTextDescriptionDialog(product: any) {
	  const dialogRef = this.dialog.open(TextDescriptionDialogComponent, {
	    width: '400px',
	    data: { product }
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result?.description !== undefined) {
	      product.description = result.description;
	      this.updateProductInStock(product);
		  this.showSuccessSnackBar('Description mise à jour avec succès.');
	    }
	  });
	}

	openAudioDescriptionDialog(product: any) {
	  const dialogRef = this.dialog.open(AudioDescriptionDialogComponent, {
	    width: '400px',
	    data: { product }
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result?.audioUrl !== undefined) {
	      product.audioUrl = result.audioUrl;
	      this.updateProductInStock(product);
		  this.showSuccessSnackBar('Description Audio mise à jour avec succès.');
	    }
	  });
	}

	openQrCodeDialog(product: any) {
	  this.dialog.open(QrCodeDescriptionDialogComponent, {
	    width: '300px',
	    data: { product }
	  });
	}

	openPhotoDialog(product: any) {
	  const dialogRef = this.dialog.open(PhotoDialogComponent, {
	    width: '500px',
	    data: { product }
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result?.imageUrl !== undefined) {
	      product.imageUrl = result.imageUrl;
	      this.updateProductInStock(product);
	      this.showSuccessSnackBar('Photo mis à jour avec succès.');
	    }
	  });
	}

	triggerFileUpload() {
	  this.fileInput.nativeElement.click(); // Ouvre l'explorateur de fichiers
	}

	handleFileUpload(event: any) {
	  const file = event.target.files[0];
	  if (!file) return;

	  const reader = new FileReader();
	  reader.onload = (e: any) => {
	    const data = new Uint8Array(e.target.result);
	    const workbook = XLSX.read(data, { type: 'array' });
	    const sheetName = workbook.SheetNames[0];
	    const sheet = workbook.Sheets[sheetName];
	    const jsonData = XLSX.utils.sheet_to_json(sheet);
  
	    // Convertir les données en objets conformes au modèle attendu
	    this.previewProducts = jsonData.map((item: any) => ({
	      ref: item['REFERENCE'] || 'Produit sans nom',
	      designation: item['DESIGNATION'] ?? 0,
	      qteStock: item['QTE STOCK'] ??  item[' QTE STOCK '] ?? 0,
	      cmup: item['PR CMUP'] ?? item[' PR CMUP '] ?? 0,
	      gros: item['PV EN GROS'] || 0,
	      demiGros: item['DEMI GROS'] || 0,
	      detail: item['DETAIL'] ?? 0,
	      audioUrl: '',  // Laisse vide car il n'y a pas d'importation d'audio
	      imageUrl: '',  // Laisse vide car il n'y a pas d'importation d'audio
	    }));

	    this.closestockAdjustInDialog() ;
	    console.log(this.previewProducts); // Vérifie que les données sont bien formatées
	  };
	  reader.readAsArrayBuffer(file);
	}


  onTabChange(event){

    //if(event.index==0)
  }


	toggleSearch() {
		this.showSearch = !this.showSearch;
		this.showFilter = false; // Cache le filtre si on affiche la recherche
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
		this.showSearch = false; // Cache la recherche si on affiche les filtres
	}

	getUniqueCategories(): string[] {
	  const categories: string[] = [];
	  this.products.forEach(product => {
	    if (!categories.includes(product.category)) {
	      categories.push(product.category);
	    }
	  });
	  return categories;
	}


	updateProductInStock(updatedProduct: any) {
	  const index = this.products.findIndex(p => p.id === updatedProduct.id);
	  if (index !== -1) {
	    this.products[index] = { ...updatedProduct };
	  }

	  console.log("UPDATED PRODUCT") ;
	  console.log(this.products[index]) ;
	  
	  // Si tu utilises un backend ou stockage local, ajoute ça :
	  // this.stockService.save(this.products);
	}



  //get filteredProducts() {
  get filteredProducts() {
    return this.products.filter(product => {
      const matchesSearch = this.searchTerm === '' || product.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      const matchesCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(product.category);
      return matchesSearch && matchesCategory;
    });
  }

	get paginatedProducts() {
	  const start = (this.currentPage - 1) * this.itemsPerPage;
	  const end = start + this.itemsPerPage;
	  return this.filteredProducts.slice(start, end);
	}


    onCategChoose(event){
		this.currentPage = 1;
    }


	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.searchTerm = filterValue.trim().toLowerCase();
	}


	showSuccessSnackBar(message: string) {
	  this.snackBar.open(message, 'Fermer', {
	    duration: 3000,
	    horizontalPosition: 'right',
	    verticalPosition: 'bottom',
	    panelClass: ['custom-snackbar']
	  });
	}

	toggleSelection(product: any) {
	  const index = this.selectedProducts.indexOf(product);
	  if (index === -1) {
	    this.selectedProducts.push(product);
	  } else {
	    this.selectedProducts.splice(index, 1);
	  }
	}

	isSelected(product: any): boolean {
	  return this.selectedProducts.includes(product);
	}


	toggleSelectAll() {
	  if (this.areAllSelected()) {
	    this.selectedProducts = [];
	  } else {
	    this.selectedProducts = [...this.filteredProducts];
	  }
	}

	areAllSelected(): boolean {
	  return this.selectedProducts.length === this.filteredProducts.length;
	}

	changeCategoryForSelected() {
	  if (this.newCategory) {
	  	this.mettreAjourCategArtMasse() ;
	  }
	}

	mettreAjourCategArtMasse(){
		this.openSpinnerDialog() ;
		this.configServer.mettreAjourCategArtMasse(this.samacaabiyoonwii, this.selectedProducts, this.newCategory).then( (retourbi) => {
		  this.closeSpinnerDialog() ;
		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    this.selectedProducts.forEach(product => {
		      product.category = this.newCategory;
		    });
		    this.selectedProducts = []; // Reset après changement
		    this.newCategory = '';
		    //this.etatreq='successful' ;
		    console.log("Mbirr Yi Matna") ;
		  }
		  else{
		    //this.etatreq='failed' ;
		    console.log("Failed") ;
		  }
		}) ;    
	}


	applyCollectiveChange() {
	  this.selectedProducts.forEach(product => {
	    // Exemple : changer le prix de vente
	    product.salePrice += 10; // ou ouvrir un dialog pour définir la nouvelle valeur
	  });
	}

	openAddDepotDialog(product: any) {
	  const dialogRef = this.dialog.open(DepotDialogComponent, {
	    data: { mode: 'add', product, boutique:this.selectedBoutique },
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result) {
	      product.quantity.stocksParDepot.push(result);
	      this.updateQteTotal(product);
	      this.snackBar.open('Dépôt ajouté', 'Fermer', { duration: 2000 });
	    }
	  });
	}

	openEditDepotDialog(product: any, depot: any) {
	  const dialogRef = this.dialog.open(DepotDialogComponent, {
	    data: { mode: 'edit', product, depot },
	  });

	  dialogRef.afterClosed().subscribe(result => {
	    if (result) {
	      Object.assign(depot, result);
	      this.updateQteTotal(product);
	      this.snackBar.open('Dépôt modifié', 'Fermer', { duration: 2000 });
	    }
	  });
	}

	removeDepot(product: any, depot: any) {
	  product.quantity.stocksParDepot = product.quantity.stocksParDepot.filter(d => d !== depot);
	  this.updateQteTotal(product);
	  this.snackBar.open('Dépôt supprimé', 'Fermer', { duration: 2000 });
	}

	updateQteTotal(product: any) {
	  product.quantity.qteTotal = product.quantity.stocksParDepot
	    .reduce((acc: number, d: any) => acc + Number(d.qteEnStock || 0), 0);
	}


  // Fonction de mise à jour du stock (entrée et sortie)
  updateStock(product: any) {
    if (product.stockIn > 0) {
      product.quantity += product.stockIn; // Ajouter au stock
      product.stockIn = 0; // Réinitialiser l'entrée
    }
    if (product.stockOut > 0) {
      if (product.stockOut <= product.quantity) {
        product.quantity -= product.stockOut; // Retirer du stock
        product.stockOut = 0; // Réinitialiser la sortie
      } else {
        alert('Impossible de retirer plus que la quantité disponible.');
        product.stockOut = 0;
      }
    }
    alert(`Stock mis à jour: ${product.quantity} unités pour ${product.name}`);
  }

  // Fonction pour gérer le changement de fichier audio
  onAudioFileChange(event: any, product: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        product.audioUrl = reader.result as string; // Stocker l'URL du fichier audio
      };
      reader.readAsDataURL(file);
    }
  }

  // Fonction pour mettre à jour le produit (description et audio)
  updateProduct(product: any) {
    console.log('Produit mis à jour:', product);
    // Ajouter ici la logique pour envoyer les données mises à jour au serveur
  }

  openstockAdjustInDialog() {
    this.stockAdjustInDialogRef = this.dialog.open(this.stockAdjustInDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  closestockAdjustInDialog() {
    this.stockAdjustInDialogRef.close();
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
